/* Publik analyskatalog — sök bland vattenanalyserna.
 *
 * Data kommer från apps.svensktvattenprov.se/.netlify/functions/katalog-publik,
 * som svarar UTAN priser, utan beställningskoder och utan leverantör. Den här
 * filen ska aldrig behöva veta något om det: den renderar vad den får.
 *
 * TVÅ SAKER SOM ÄR LÄTTA ATT GÖRA FEL HÄR:
 *
 * 1. Varje träff får en RIKTIG <a href="?a=id">. Inte en knapp med onclick.
 *    Hela poängen är att sökmotorer ska kunna följa länkarna till varje
 *    analys — en knapp är en återvändsgränd för en crawler, och en högerklick
 *    + "öppna i ny flik" fungerar inte heller.
 * 2. Sökningen stryps (debounce) men avbryts ALDRIG tyst. Ett svar som kommer
 *    efter ett nyare svar kastas via en räknare, annars kan en långsam
 *    förfrågan skriva över en färskare träfflista.
 */
(function () {
  'use strict';

  var API = 'https://apps.svensktvattenprov.se/.netlify/functions/katalog-publik';
  var API_FORFRAGAN = 'https://apps.svensktvattenprov.se/.netlify/functions/katalog-forfragan';
  var KORG_NYCKEL = 'svp-analyskorg';
  var KORG_MAX = 60;
  // TIO, inte tjugo. Tjugo kort fyllde hela skärmen och offertbyggaren längst
  // ner på sidan syntes aldrig – man förstod inte att analyserna samlades
  // någonstans. Med tio ryms "Visa fler analyser" och korgen i samma vy.
  var PER = 10;             // träffar per sida innan "Visa fler analyser"
  var KORG_VISA = 6;        // så många syns innan formuläret; resten fälls ut
  var rot = document.querySelector('[data-svp-katalog]');
  if (!rot) return;

  var elSok = rot.querySelector('[data-k-sok]');
  var elProvtyp = rot.querySelector('[data-k-provtyp]');
  var elAckChips = rot.querySelector('[data-k-ack-chips]');
  var ackVal = '';   // '' = alla, '1' = ackrediterade, '0' = ej ackrediterade
  var elStatus = rot.querySelector('[data-k-status]');
  var elTraffar = rot.querySelector('[data-k-traffar]');
  var elMer = rot.querySelector('[data-k-mer]');
  var elStart = rot.querySelector('[data-k-start]');
  var elDetalj = rot.querySelector('[data-k-detalj]');
  var elSokdel = rot.querySelector('[data-k-sokdel]');
  var elSort = rot.querySelector('[data-k-sort]');
  var elExpress = rot.querySelector('[data-k-express]');
  var elPanel = rot.querySelector('[data-k-panel]');
  var elFler = rot.querySelector('[data-k-fler]');
  var elSvarstid = rot.querySelector('[data-k-svarstid]');
  var elProvtypChips = rot.querySelector('[data-k-provtyp-chips]');
  var elAktiva = rot.querySelector('[data-k-aktiva]');

  var sida = 0, antal = 0, laddar = false, varv = 0, sistaFraga = '';
  var svarstidMax = null;   // null = inget tak valt
  var fasetter = null;

  function text(s) { return String(s == null ? '' : s); }
  function esc(s) {
    return text(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function nummer(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }

  // --- korgen -------------------------------------------------------------
  //
  // Ligger i localStorage, inte i minnet: besökaren klickar in på en analys,
  // backar, söker vidare och ska inte tappa det hen valt. Varje läsning och
  // skrivning är inlindad – i privat läge kastar localStorage, och då ska
  // katalogen fortfarande fungera, bara utan att komma ihåg korgen.
  // Kundvagnen ritas som SVG i knappen. Både kortHtml och markeraKnappar
  // skriver knappens innehåll, så etiketterna bor HÄR – stod de på två ställen
  // tappade knappen sin ikon så fort man klickade på den.
  var IKON_KORG = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"' +
    ' d="M3 4h2.2l2.1 10.4a1.6 1.6 0 0 0 1.6 1.3h8.3a1.6 1.6 0 0 0 1.6-1.25L20.5 7.5H6.1"/>' +
    '<circle cx="9.5" cy="19.5" r="1.4" fill="currentColor"/>' +
    '<circle cx="17.5" cy="19.5" r="1.4" fill="currentColor"/></svg>';
  var IKON_BOCK = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"' +
    ' stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7"/></svg>';
  function knappInnehall(med) {
    return med ? IKON_BOCK + '<span>Tillagd i din offert</span>'
      : IKON_KORG + '<span>Lägg till i offert</span>';
  }

  var korg = [];
  var korgUtfalld = false;
  function korgLas() {
    try {
      var r = JSON.parse(localStorage.getItem(KORG_NYCKEL) || '[]');
      return Array.isArray(r) ? r.filter(function (x) { return x && x.id; }).slice(0, KORG_MAX) : [];
    } catch (e) { return []; }
  }
  function korgSpara() {
    try { localStorage.setItem(KORG_NYCKEL, JSON.stringify(korg)); } catch (e) { /* privat läge */ }
  }
  function iKorgen(id) {
    for (var i = 0; i < korg.length; i++) if (korg[i].id === id) return true;
    return false;
  }
  function korgLaggTill(a) {
    if (iKorgen(a.id) || korg.length >= KORG_MAX) return false;
    korg.push({ id: a.id, namn: a.namn, provtyp: a.provtyp || '' });
    korgSpara(); ritaKorg(); markeraKnappar(); ritaFlyt(true);
    return true;
  }
  function korgTaBort(id) {
    korg = korg.filter(function (x) { return x.id !== id; });
    korgSpara(); ritaKorg(); markeraKnappar(); ritaFlyt(false);
  }

  // Filtren på ett ställe: både frågan till API:t och adressfältet byggs av
  // samma objekt, så en delad länk alltid ger samma träfflista som skärmen.
  function aktivaFilter() {
    return {
      q: elSok.value.trim(),
      provtyp: elProvtyp.value || '',
      ackrediterad: ackVal,
      express: elExpress && elExpress.checked ? '1' : '',
      svarstid_max: svarstidMax == null ? '' : String(svarstidMax),
      sort: elSort ? elSort.value : 'relevans',
    };
  }

  function fragaUrl(extra) {
    var f = aktivaFilter();
    var p = new URLSearchParams();
    for (var k in f) if (f[k]) p.set(k, f[k]);
    p.set('sida', String(extra && extra.sida != null ? extra.sida : sida));
    p.set('per', String(PER));
    return API + '?' + p.toString();
  }

  // Adressfältet speglar filtren utan att ladda om sidan. Den som delar
  // länken får samma vy, och tillbaka-knappen fungerar.
  function skrivAdress() {
    if (!window.history || !history.replaceState) return;
    var f = aktivaFilter();
    var p = new URLSearchParams();
    for (var k in f) if (f[k] && !(k === 'sort' && f[k] === 'relevans')) p.set(k, f[k]);
    // `page` hör till det serverrenderade registret längst ner, inte till
    // sökningen. Skrevs det över hoppade registret tillbaka till sida 1 vid
    // nästa omladdning, trots att besökaren bläddrat vidare.
    var sidaNu = new URLSearchParams(location.search).get('page');
    if (sidaNu) p.set('page', sidaNu);
    var q = p.toString();
    try { history.replaceState(null, '', location.pathname + (q ? '?' + q : '')); } catch (e) { /* ignorera */ }
  }

  // Läser tillbaka filtren ur adressen vid sidladdning.
  function lasAdress() {
    var p = new URLSearchParams(location.search);
    if (p.get('q')) elSok.value = p.get('q');
    if (p.get('ackrediterad') === '1' || p.get('ackrediterad') === '0') ackVal = p.get('ackrediterad');
    if (p.get('express') === '1' && elExpress) elExpress.checked = true;
    // svarstid_max i en gammal delad länk ignoreras: filtret finns inte längre
    // och hade annars filtrerat osynligt. Samma för sort=svarstid.
    var sort = p.get('sort');
    if (sort && elSort && Array.prototype.some.call(elSort.options, function (o) { return o.value === sort; })) elSort.value = sort;
    // provtyp sätts när fasetterna laddat – rullisten är tom innan dess.
    return p.get('provtyp') || '';
  }

  // Kunden ser löftet 10–12 arbetsdagar (ägaren 2026-10-31) – utom där labbet
  // behöver MER än 12 dagar, för då vore löftet osant. Samma regel som appens
  // svarstid-lofte.js.
  function svarstid(a) {
    var n = Number(a && a.svarstid_dagar);
    return a && a.svarstid_dagar != null && isFinite(n) && n > 12 ? n + ' arbetsdagar' : '10–12 arbetsdagar';
  }

  // Elva provtyper får inte bli en elva ord lång ögonbrynsrad. Två plus ett
  // antal säger samma sak och håller korten lika höga.
  function provtypRad(a) {
    var lista = a.provtyper && a.provtyper.length ? a.provtyper : (a.provtyp ? [a.provtyp] : []);
    if (!lista.length) return '';
    if (lista.length <= 2) return lista.join(' · ');
    return lista.slice(0, 2).join(' · ') + ' +' + (lista.length - 2);
  }

  function kortHtml(a) {
    // A1 "Lugn": EN färg per kort, och den sitter på det man klickar på.
    // Förut bar kortet fyra: grå ögonbrynsrad, blått namn, grå platta, grön
    // platta och blå knapp – tjugo kort gav åttio färgfält på en skärm.
    // Fakta är nu en grå rad text i stället för plattor. "Ackrediterad" fick
    // egen grön platta trots att nästan VARJE analys är ackrediterad; ett
    // märke som alla har skiljer ingenting och kostar en färg per kort.
    var fakta = [];
    var s = svarstid(a);
    if (s) fakta.push('<b>' + esc(s) + '</b>');
    var antalPar = (a.parametrar || []).length;
    if (antalPar > 1) fakta.push(antalPar + ' parametrar');
    if ((a.parametrar || []).some(function (p) { return p.ackrediterad; })) fakta.push('ackrediterad');

    var matchning = '';
    if (a.matchning && a.matchning.length) {
      // Utan den här raden ser en innehållsträff ut som brus: analysen heter
      // något helt annat än det användaren sökte på.
      matchning = '<p class="svp-ak-match">Matchar: ' +
        esc(a.matchning.slice(0, 4).join(', ')) +
        (a.matchning.length > 4 ? ' m.fl.' : '') + '</p>';
    }
    return '<li class="svp-ak-kort">' +
      '<a class="svp-ak-kort__a" href="?a=' + encodeURIComponent(a.id) + '">' +
      // Provtypen FÖRST: samma analysnamn finns en gång per provtyp, så det är
      // provtypen som skiljer två kort åt.
      (provtypRad(a) ? '<span class="svp-ak-kort__provtyp">' + esc(provtypRad(a)) + '</span>' : '') +
      '<span class="svp-ak-kort__namn">' + esc(a.namn) + '</span>' +
      (fakta.length ? '<span class="svp-ak-kort__fakta">' + fakta.join(' · ') + '</span>' : '') +
      matchning + '</a>' +
      // Knappen ligger UTANFÖR länken. En <button> inuti ett <a> är ogiltig
      // HTML och klicket hade både lagt till analysen och navigerat bort.
      // Men den ligger inuti kortets egen ram, som en fotrad – se CSS:en.
      '<div class="svp-ak-kort__fot">' +
      '<button type="button" class="svp-ak-lagg" data-lagg="' + esc(a.id) + '"' +
      ' data-namn="' + esc(a.namn) + '" data-provtyp="' + esc(a.provtyp || '') + '">' +
      knappInnehall(iKorgen(a.id)) + '</button>' +
      '</div></li>';
  }

  function visaStatus(s) {
    elStatus.textContent = s;
    elStatus.hidden = !s;
  }

  // Är något valt? Startblocket ska bort så fort besökaren gjort ETT val –
  // och komma tillbaka om hon rensar allt.
  function nagotValt() {
    var f = aktivaFilter();
    return !!(f.q || f.provtyp || f.ackrediterad || f.express || f.svarstid_max
      || (f.sort && f.sort !== 'relevans'));
  }

  // Söktermen tappas tyst om varje ord är kortare än två tecken: tokens() i
  // API:t slänger dem, och UTAN ord blir frågan ofiltrerad – alltså hela
  // katalogen. Ett "U" såg därför ut att matcha 2 818 analyser. Hellre säga
  // vad som krävs än visa allt och låta besökaren tro att sökningen är trasig.
  function forKort() {
    var q = elSok.value.trim();
    if (!q) return false;
    var ord = q.split(/[\s,;]+/).filter(function (t) { return t.length >= 2; });
    return ord.length === 0;
  }

  function hamta(aterstall) {
    if (laddar) return;
    laddar = true;
    var mitt = ++varv;
    var url = fragaUrl();
    if (aterstall) { visaStatus('Söker …'); }
    if (elStart) elStart.hidden = true;
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('svar ' + r.status); return r.json(); })
      .then(function (d) {
        if (mitt !== varv) return;          // ett nyare svar har redan ritats
        antal = d.antal || 0;
        var html = (d.analyser || []).map(kortHtml).join('');
        if (aterstall) elTraffar.innerHTML = html;
        else elTraffar.insertAdjacentHTML('beforeend', html);
        var visade = elTraffar.children.length;
        visaStatus(antal === 0
          ? 'Inga analyser matchar sökningen.'
          : 'Visar ' + nummer(visade) + ' av ' + nummer(antal) + ' analyser.');
        var fler = visade < (d.antal_sidbart != null ? d.antal_sidbart : antal);
        elMer.hidden = !fler;
      })
      .catch(function () {
        if (mitt !== varv) return;
        visaStatus('Katalogen kunde inte läsas just nu. Försök igen om en stund.');
      })
      .then(function () { laddar = false; });
  }

  var timer = null;
  function sokOm() {
    // Nyckeln måste täcka ALLA filter. Täckte den bara fritexten gjorde ett
    // klick på ett chip ingenting, eftersom frågan såg oförändrad ut.
    var f = aktivaFilter();
    var nyckel = JSON.stringify(f);
    if (nyckel === sistaFraga) return;
    sistaFraga = nyckel;
    sida = 0;
    ritaAktiva();
    skrivAdress();
    if (elStart) elStart.hidden = nagotValt();
    if (!nagotValt()) {
      // Tillbaka till startläget: inga kort, ingen status, bara de två vägarna.
      elTraffar.innerHTML = '';
      elMer.hidden = true;
      visaStatus('');
      hamtaFasetter();
      return;
    }
    if (forKort()) {
      elTraffar.innerHTML = '';
      elMer.hidden = true;
      visaStatus('Skriv minst två tecken för att söka.');
      return;
    }
    hamta(true);
    hamtaFasetter();
  }
  function strypt() { clearTimeout(timer); timer = setTimeout(sokOm, 250); }

  elSok.addEventListener('input', strypt);
  elProvtyp.addEventListener('change', sokOm);
  if (elExpress) elExpress.addEventListener('change', sokOm);
  if (elSort) elSort.addEventListener('change', sokOm);
  if (elFler) elFler.addEventListener('click', function () {
    var oppen = elFler.getAttribute('aria-expanded') === 'true';
    elFler.setAttribute('aria-expanded', oppen ? 'false' : 'true');
    elPanel.hidden = oppen;
  });
  rot.querySelector('[data-k-form]').addEventListener('submit', function (e) {
    e.preventDefault(); clearTimeout(timer); sokOm();
  });
  elMer.addEventListener('click', function () { sida += 1; hamta(false); });

  var elTillRegister = rot.querySelector('[data-k-till-register]');
  if (elTillRegister) elTillRegister.addEventListener('click', function () {
    var reg = rot.querySelector('.svp-ak-register');
    if (!reg) return;
    reg.open = true;
    reg.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // --- fasetter och chips --------------------------------------------------

  function chip(etikett, antalTraffar, vald, attr) {
    return '<button type="button" class="svp-ak-chip' + (antalTraffar === 0 ? ' ar-tom' : '') +
      '" aria-pressed="' + (vald ? 'true' : 'false') + '" ' + attr + '>' +
      '<b>' + esc(etikett) + '</b>' +
      (antalTraffar != null ? ' <span>' + nummer(antalTraffar) + '</span>' : '') + '</button>';
  }

  function ritaFasetter(onskadProvtyp) {
    if (!fasetter) return;
    // Provtyp finns BÅDE som rullist och som chips. Rullisten är kvar för
    // tangentbord och små skärmar; chipsen gör de vanligaste valen till ett
    // klick. De speglar samma värde, så de kan inte glida isär.
    elProvtyp.innerHTML = '<option value="">Alla provtyper</option>';
    (fasetter.provtyper || []).forEach(function (p) {
      var o = document.createElement('option');
      o.value = p.provtyp;
      o.textContent = p.provtyp + ' (' + p.antal + ')';
      elProvtyp.appendChild(o);
    });
    if (onskadProvtyp) elProvtyp.value = onskadProvtyp;

    if (elProvtypChips) {
      elProvtypChips.innerHTML = (fasetter.provtyper || []).slice(0, 10).map(function (p) {
        return chip(p.provtyp, p.antal, elProvtyp.value === p.provtyp,
          'data-provtyp="' + esc(p.provtyp) + '"');
      }).join('');
    }
    if (elSvarstid) {
      elSvarstid.innerHTML = (fasetter.svarstid || []).map(function (x) {
        return chip('Högst ' + x.dagar + ' dagar', x.antal, svarstidMax === x.dagar,
          'data-svarstid="' + x.dagar + '"');
      }).join('');
    }
    var a1 = rot.querySelector('[data-k-ack-antal]');
    if (a1 && fasetter.ackrediterade != null) a1.textContent = '(' + nummer(fasetter.ackrediterade) + ')';
    if (elAckChips) {
      var ack = fasetter.ackrediterade, ej = fasetter.ej_ackrediterade;
      // "Alla" tar serverns EGEN totalsiffra för dimensionen, aldrig summan av
      // de två. Summan ljög på två sätt: saknades ett fält (gammal cachepost)
      // blev den tyst för låg – 2 522 i chipet mot "2 819 analyser" i listan –
      // och en analys utan parametrar räknas i ingendera, så 2 524 + 297 blev
      // 2 821 medan sökningen gav 2 819.
      var allaAck = fasetter.ack_alla;
      if (allaAck == null) allaAck = fasetter.antal;
      elAckChips.innerHTML =
        chip('Alla', allaAck, ackVal === '', 'data-ack=""') +
        chip('Ackrediterade', ack, ackVal === '1', 'data-ack="1"') +
        chip('Ej ackrediterade', ej, ackVal === '0', 'data-ack="0"');
    }

    // Express döljs helt när ingen vattenanalys har det. Ett filter som alltid
    // ger noll träffar är sämre än inget filter: det ser ut som ett fel.
    // (Mätt 2026-10-03: noll av 2 819 vattenanalyser är märkta express.)
    var a2 = rot.querySelector('[data-k-express-antal]');
    var expressGrupp = rot.querySelector('[data-k-express-grupp]');
    if (!fasetter.express) {
      if (expressGrupp) expressGrupp.hidden = true;
      if (elExpress) elExpress.checked = false;
    } else {
      if (expressGrupp) expressGrupp.hidden = false;
      if (a2) a2.textContent = '(' + nummer(fasetter.express) + ')';
    }
    var r = rot.querySelector('[data-k-antal]');
    if (r && fasetter.antal) r.textContent = nummer(fasetter.antal);
  }

  // Raden med valda filter. Finns för att ett filter som ligger i en hopfälld
  // panel annars är osynligt: man ser tolv träffar och förstår inte varför.
  function ritaAktiva() {
    if (!elAktiva) return;
    var valda = [];
    if (elProvtyp.value) valda.push(['provtyp', elProvtyp.value]);
    if (svarstidMax != null) valda.push(['svarstid', 'Högst ' + svarstidMax + ' dagar']);
    if (ackVal === '1') valda.push(['ack', 'Ackrediterade']);
    if (ackVal === '0') valda.push(['ack', 'Ej ackrediterade']);
    if (elExpress && elExpress.checked) valda.push(['express', 'Express']);
    if (!valda.length) { elAktiva.hidden = true; elAktiva.innerHTML = ''; return; }
    elAktiva.hidden = false;
    elAktiva.innerHTML = '<span class="svp-ak-aktiv-etikett">Filter:</span> ' +
      valda.map(function (v) {
        return '<button type="button" class="svp-ak-aktiv" data-rensa="' + v[0] + '">' + esc(v[1]) + '</button>';
      }).join('') +
      ' <button type="button" class="svp-ak-rensa" data-rensa="alla">Rensa alla</button>';
  }

  function rensa(vad) {
    if (vad === 'alla') {
      elSok.value = ''; elProvtyp.value = ''; svarstidMax = null; ackVal = '';
      if (elExpress) elExpress.checked = false;
    }
    if (vad === 'provtyp') elProvtyp.value = '';
    if (vad === 'svarstid') svarstidMax = null;
    if (vad === 'ack') ackVal = '';
    if (vad === 'express' && elExpress) elExpress.checked = false;
    ritaFasetter(elProvtyp.value);
    sokOm();
  }

  rot.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-svarstid],[data-provtyp],[data-ack],[data-rensa]') : null;
    if (!el) return;
    if (el.hasAttribute('data-rensa')) { rensa(el.getAttribute('data-rensa')); return; }
    if (el.hasAttribute('data-ack')) {
      ackVal = el.getAttribute('data-ack');
    } else if (el.hasAttribute('data-svarstid')) {
      var d = Number(el.getAttribute('data-svarstid'));
      svarstidMax = (svarstidMax === d) ? null : d;      // klick på valt chip rensar
    } else {
      var t = el.getAttribute('data-provtyp');
      elProvtyp.value = (elProvtyp.value === t) ? '' : t;
    }
    ritaFasetter(elProvtyp.value);
    sokOm();
  });

  // Fasetterna följer sökningen: siffrorna visar hur många träffar varje val
  // skulle ge I DEN AKTUELLA sökningen, inte i hela katalogen.
  var metaVarv = 0;
  function hamtaFasetter(onskadProvtyp) {
    var f = aktivaFilter();
    var p = new URLSearchParams();
    for (var k in f) if (f[k] && k !== 'sort') p.set(k, f[k]);
    p.set('meta', '1');
    var mitt = ++metaVarv;
    return fetch(API + '?' + p.toString())
      .then(function (r) { return r.json(); })
      .then(function (d) {
        // Ett äldre svar får aldrig rita över ett nyare – siffrorna hade
        // annars kunnat visa en tidigare sökning.
        if (mitt !== metaVarv) return;
        fasetter = d;
        ritaFasetter(onskadProvtyp != null ? onskadProvtyp : elProvtyp.value);
      })
      .catch(function () { /* filtren är en bonus – sökningen fungerar utan dem */ });
  }

  var onskadProvtyp = lasAdress();
  hamtaFasetter(onskadProvtyp).then(function () {
    if (onskadProvtyp) { ritaAktiva(); sokOm(); }
  });
  ritaAktiva();

  // --- korgpanelen ---------------------------------------------------------
  var elKorg = document.querySelector('[data-k-korg]');

  function markeraKnappar() {
    var knappar = rot.querySelectorAll('[data-lagg]');
    for (var i = 0; i < knappar.length; i++) {
      var k = knappar[i];
      var med = iKorgen(k.getAttribute('data-lagg'));
      k.innerHTML = knappInnehall(med);
      k.classList.toggle('ar-tillagd', med);
    }
  }

  // Räknaren i hörnet. Korgen ligger längst ner på en sida med tjugofyra
  // träffar, så utan den här syntes det inte att klicket gjorde något.
  var elFlyt = rot.querySelector('[data-k-flyt]');
  var elFlytAntal = rot.querySelector('[data-k-flyt-antal]');
  function ritaFlyt(puls) {
    if (!elFlyt) return;
    elFlyt.hidden = korg.length === 0;
    if (elFlytAntal) elFlytAntal.textContent = String(korg.length);
    if (puls && korg.length) {
      elFlyt.classList.remove('ar-puls');
      void elFlyt.offsetWidth;          // tvingar animationen att börja om
      elFlyt.classList.add('ar-puls');
    }
  }
  if (elFlyt) {
    elFlyt.addEventListener('click', function () {
      var mal = document.querySelector('[data-k-korg]');
      if (!mal || mal.hidden) return;
      mal.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function ritaKorg() {
    if (!elKorg) return;
    if (!korg.length) { elKorg.hidden = true; elKorg.innerHTML = ''; return; }
    elKorg.hidden = false;
    // Lång lista = formuläret hamnar utanför skärmen. Med trettio valda
    // analyser syntes varken fälten eller skicka-knappen, och sidan såg ut att
    // sakna formulär. Visa de första, fäll ut resten på begäran.
    var visa = korgUtfalld ? korg.length : Math.min(korg.length, KORG_VISA);
    var dolda = korg.length - visa;
    elKorg.innerHTML =
      '<h2 class="svp-ak-korg__rubrik">Din offertförfrågan (' + korg.length + ')</h2>' +
      '<ul class="svp-ak-korg__lista">' + korg.slice(0, visa).map(function (x) {
        return '<li><span>' + esc(x.namn) + (x.provtyp ? ' <em>' + esc(x.provtyp) + '</em>' : '') + '</span>' +
          '<button type="button" class="svp-ak-korg__bort" data-bort="' + esc(x.id) + '"' +
          ' aria-label="Ta bort ' + esc(x.namn) + '">&times;</button></li>';
      }).join('') + '</ul>' +
      // Knappen ligger UTANFÖR <ul>: raderna i listan är en flexrad med egen
      // indragning, och en knapp i ett <li> hade fått dubbel indragning.
      (dolda > 0
        ? '<button type="button" class="svp-ak-korg__fler" data-korg-fler>Visa alla '
          + korg.length + ' analyser (' + dolda + ' till)</button>'
        : (korg.length > KORG_VISA
          ? '<button type="button" class="svp-ak-korg__fler" data-korg-fler>Visa färre</button>'
          : '')) +
      '<form class="svp-ak-korg__form" data-korg-form novalidate>' +
      '<div class="svp-ak-korg__rad">' +
      '<label>Namn *<input name="namn" required autocomplete="name"></label>' +
      '<label>Organisation eller förening<input name="organisation" autocomplete="organization"></label>' +
      '</div>' +
      '<div class="svp-ak-korg__rad">' +
      '<label>E-post<input name="email" type="email" autocomplete="email"></label>' +
      '<label>Telefon<input name="telefon" type="tel" autocomplete="tel"></label>' +
      '</div>' +
      '<div class="svp-ak-korg__rad">' +
      '<label>Antal prov<input name="antal_prov" inputmode="numeric" placeholder="t.ex. 14"></label>' +
      '</div>' +
      '<label>Meddelande<textarea name="meddelande" rows="3" placeholder="Berätta gärna vad analysen ska användas till, hur många provpunkter det gäller och när du behöver svaret."></textarea></label>' +
      // Honungsfällan: dold för öga och skärmläsare, ifylld bara av robotar.
      '<div class="svp-ak-falla" aria-hidden="true"><label>Webbplats<input name="webbplats" tabindex="-1" autocomplete="off"></label></div>' +
      '<p class="svp-ak-korg__not">Vi räknar på ditt antal prov och återkommer med en offert. ' +
      'Ingen beställning läggs och inget debiteras.</p>' +
      '<button type="submit" class="svp-ak-knapp">Skicka offertförfrågan</button>' +
      '<p class="svp-ak-korg__svar" data-korg-svar role="status"></p>' +
      '</form>';
  }

  if (elKorg) {
    // Delegerade klick: korgen och träfflistan ritas om hela tiden, och
    // lyssnare på varje knapp hade fått sättas om vid varje rendering.
    rot.addEventListener('click', function (e) {
      var lagg = e.target.closest ? e.target.closest('[data-lagg]') : null;
      if (lagg) {
        korgLaggTill({ id: lagg.getAttribute('data-lagg'), namn: lagg.getAttribute('data-namn'),
          provtyp: lagg.getAttribute('data-provtyp') });
        return;
      }
      if (e.target.closest && e.target.closest('[data-korg-fler]')) {
        korgUtfalld = !korgUtfalld; ritaKorg();
        return;
      }
      var bort = e.target.closest ? e.target.closest('[data-bort]') : null;
      if (bort) korgTaBort(bort.getAttribute('data-bort'));
    });

    rot.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-korg-form]') : null;
      if (!form) return;
      e.preventDefault();
      var svar = form.querySelector('[data-korg-svar]');
      var knapp = form.querySelector('button[type="submit"]');
      var d = {
        namn: form.namn.value, organisation: form.organisation.value,
        email: form.email.value, telefon: form.telefon.value,
        antal_prov: form.antal_prov.value, meddelande: form.meddelande.value,
        webbplats: form.webbplats.value,
        analyser: korg.map(function (x) { return x.id; }),
      };
      if (!d.namn.trim()) { svar.textContent = 'Fyll i ditt namn.'; return; }
      if (!d.email.trim() && !d.telefon.trim()) { svar.textContent = 'Fyll i e-post eller telefon så vi kan svara.'; return; }
      knapp.disabled = true;
      svar.textContent = 'Skickar …';
      fetch(API_FORFRAGAN, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d),
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && res.j.error) || 'fel');
          korg = []; korgSpara();
          elKorg.innerHTML = '<div class="svp-ak-korg__klart"><h2>Tack, vi har tagit emot din förfrågan.</h2>' +
            '<p>Vi räknar på ditt antal prov och hör av oss. Har du bråttom når du oss på ' +
            '<a href="tel:+46105558723">010-555 87 23</a>.</p></div>';
          markeraKnappar(); ritaFlyt(false);
        })
        .catch(function (e2) {
          knapp.disabled = false;
          svar.textContent = (e2 && e2.message) || 'Det gick inte att skicka just nu. Försök igen om en stund.';
        });
    });
  }

  korg = korgLas();
  ritaKorg();
  ritaFlyt(false);

  // --- detaljvy ------------------------------------------------------------
  function parametertabell(a) {
    if (!a.parametrar || !a.parametrar.length) return '';
    var rader = a.parametrar.map(function (p) {
      return '<tr><th scope="row">' + esc(p.namn) + '</th>' +
        '<td>' + esc(p.rapportgrans && p.rapportgrans !== '-' ? p.rapportgrans : '–') + '</td>' +
        '<td>' + esc(p.enhet || '–') + '</td>' +
        '<td>' + esc(p.metod && p.metod !== '-' ? p.metod : '–') + '</td>' +
        '<td>' + (p.ackrediterad ? 'Ja' : 'Nej') + '</td></tr>';
    }).join('');
    return '<div class="svp-ak-tabellram"><table class="svp-ak-tabell">' +
      '<thead><tr><th scope="col">Parameter</th><th scope="col">Rapportgräns</th>' +
      '<th scope="col">Enhet</th><th scope="col">Metod</th><th scope="col">Ackrediterad</th></tr></thead>' +
      '<tbody>' + rader + '</tbody></table></div>';
  }

  function visaDetalj(a) {
    var s = svarstid(a);
    var fakta = [];
    var provtyper = a.provtyper && a.provtyper.length ? a.provtyper : (a.provtyp ? [a.provtyp] : []);
    if (provtyper.length) fakta.push([provtyper.length > 1 ? 'Provtyper' : 'Provtyp', provtyper.join(', ')]);
    if (s) fakta.push(['Svarstid', s]);
    if (a.provkarl) fakta.push(['Provkärl', a.provkarl]);
    if (a.parametrar && a.parametrar.length) fakta.push(['Antal parametrar', String(a.parametrar.length)]);

    elDetalj.innerHTML =
      '<p class="svp-ak-tillbaka"><a href="' + location.pathname + '">&larr; Tillbaka till katalogen</a></p>' +
      '<h1 class="svp-ak-h1">' + esc(a.namn) + '</h1>' +
      '<dl class="svp-ak-fakta">' + fakta.map(function (f) {
        return '<div><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>';
      }).join('') + '</dl>' +
      parametertabell(a) +
      '<div class="svp-ak-offert">' +
      '<h2>Så här får du analysen utförd</h2>' +
      '<p>Vi tillhandahåller analysen för privatpersoner, företag, föreningar och samfälligheter. ' +
      'I priset ingår provtagningskit med rätt provkärl, fri frakt och fri returfrakt, ' +
      'analys på Swedac-ackrediterat laboratorium, bedömning mot Livsmedelsverkets riktvärden ' +
      'och en personlig genomgång av svaret.</p>' +
      '<p>Priset beror på antal prov och provtagningsomfattning, så vi räknar på just ditt fall.</p>' +
      '<button type="button" class="svp-ak-knapp" data-lagg="' + esc(a.id) + '"' +
      ' data-namn="' + esc(a.namn) + '" data-provtyp="' + esc(a.provtyp || '') + '">' +
      (iKorgen(a.id) ? 'Tillagd \u2713' : 'Lägg till i förfrågan') + '</button> ' +
      '<a class="svp-ak-knapp svp-ak-knapp--lugn" href="' + location.pathname + '">Sök fler analyser</a>' +
      '</div>';
    elDetalj.hidden = false;
    ritaKorg();
    markeraKnappar();
    // TAS BORT, inte bara döljs. Ett hidden-element ligger kvar i DOM:en, och
    // listvyns h1 hade då gett sidan TVÅ h1 – samma fel som på
    // jämförelsesidan, fast osynligt för ögat och synligt för Google.
    if (elSokdel && elSokdel.parentNode) elSokdel.parentNode.removeChild(elSokdel);

    // KANONISK ADRESS till analysens serverrenderade sida. Utan den tävlar
    // ?a=<id> med /pages/vattenanalys/<handtag> om samma innehåll, och Google
    // får två adresser för en analys – den sämre av dem ritad av JavaScript.
    // Adressen kommer från API:t (a.sida), aldrig uträknad här: kapningsregeln
    // för handtaget bor på ETT ställe, i katalog-publik.
    if (a.sida) {
      var kan = document.querySelector('link[rel="canonical"]');
      if (!kan) {
        kan = document.createElement('link');
        kan.setAttribute('rel', 'canonical');
        document.head.appendChild(kan);
      }
      kan.setAttribute('href', location.origin + a.sida);
    }

    document.title = a.namn + ' – analys av vatten | Svenskt Vattenprov';
    var md = document.querySelector('meta[name="description"]');
    if (md) {
      md.setAttribute('content', a.namn + (a.provtyp ? ' i ' + a.provtyp.toLowerCase() : '') +
        '. ' + (s ? 'Svar på ' + s + '. ' : '') + 'Ackrediterad analys hos Svenskt Vattenprov.');
    }
    var ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: a.namn,
      serviceType: 'Vattenanalys',
      areaServed: { '@type': 'Country', name: 'Sverige' },
      provider: { '@type': 'Organization', name: 'Svenskt Vattenprov', url: 'https://svensktvattenprov.se' },
      url: a.sida ? location.origin + a.sida : location.href,
    });
    document.head.appendChild(ld);
  }

  var idUr = new URLSearchParams(location.search).get('a');
  if (idUr) {
    elSokdel.hidden = true;
    fetch(API + '?id=' + encodeURIComponent(idUr))
      .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
      .then(function (d) { visaDetalj(d.analys); })
      .catch(function () {
        // Ett id som inte finns ska inte lämna en tom sida: visa katalogen.
        elSokdel.hidden = false;
        elDetalj.hidden = true;
        visaStatus('Analysen kunde inte hittas. Sök i katalogen nedan.');
        hamta(true);
      });
  } else {
    // sokOm() i stället för hamta(): den registrerar frågenyckeln, så den
    // andra sökningen när fasetterna landat bara blir av om något FAKTISKT
    // ändrats. Annars gjorde varje sidladdning två identiska anrop.
    sokOm();
  }
})();
